module.exports = __webpack_public_path__ + "static/media/img1.e9f2f795.png";